const isDevelopment = import.meta.env.DEV;

export const API_CONFIG = {
    baseUrl: import.meta.env.VITE_API_URL || (isDevelopment ? 'http://localhost:8000' : 'https://myhealth-backend.azurewebsites.net'),
    endpoints: {
        login: '/token',
        register: '/register',
        logout: '/logout',
        profile: '/profile',
        updateProfile: '/update_profile',
        meals: '/meals',
        meal: (id: string) => `/meals/${id}`,
        mealStats: '/meals/stats',
        analyzeText: '/meals/analyze-text',
        uploadPhoto: '/meals/upload',
        weight: '/weight',
        weightEntry: (date: string) => `/weight/${encodeURIComponent(date)}`,
        foodSearch: '/food/search',
        foodBarcode: '/food/barcode',
        dashboardSummary: '/dashboard/summary',
        admin: {
            users: '/admin/users',
            user: (email: string) => `/admin/users/${encodeURIComponent(email)}`,
            approve: (email: string) => `/admin/users/${encodeURIComponent(email)}/approve`,
            suspend: (email: string) => `/admin/users/${encodeURIComponent(email)}/suspend`,
            reactivate: (email: string) => `/admin/users/${encodeURIComponent(email)}/reactivate`,
            delete: (email: string) => `/admin/users/${encodeURIComponent(email)}`,
            refund: (email: string) => `/admin/users/${encodeURIComponent(email)}/refund`,
            resetPassword: (email: string) => `/admin/users/${encodeURIComponent(email)}/reset-password`,
            toggleAdmin: (email: string) => `/admin/users/${encodeURIComponent(email)}/toggle-admin`,
        },
        billing: {
            status: '/billing/status',
            createCheckout: '/billing/create-checkout-session',
        },
        insights: {
            daily: '/insights?period=daily',
            weekly: '/insights?period=weekly',
            dailyForce: '/insights?period=daily&force=true',
            weeklyForce: '/insights?period=weekly&force=true',
        },
    }
};

export const getApiUrl = (endpoint: string): string => {
    return `${API_CONFIG.baseUrl}${endpoint}`;
};

export const axiosConfig = {
    baseURL: API_CONFIG.baseUrl,
};
